const CROSSREF_BASE = 'https://api.crossref.org/works/';

/** Pulls a bare DOI out of a pasted DOI, doi.org URL, or DOI embedded in a
 * longer string of text. */
function extractDoi(input) {
  const match = input.trim().match(/10\.\d{4,9}\/\S+/);
  const doi = match ? match[0] : input.trim();
  return doi.replace(/[.,;]+$/, '');
}

/** Looks up a DOI against the CrossRef public API (no key required) and
 * normalizes the response to this app's metadata shape. Throws with a
 * message suitable for display if the DOI isn't found or the network call
 * fails — the caller falls back to manual entry either way. */
export async function fetchByDoi(input) {
  const doi = extractDoi(input);
  if (!doi) throw new Error('Enter a DOI first.');

  let res;
  try {
    res = await fetch(`${CROSSREF_BASE}${encodeURIComponent(doi)}`);
  } catch {
    throw new Error('Could not reach the DOI lookup service — check your connection or enter details manually.');
  }
  if (!res.ok) {
    throw new Error(res.status === 404 ? `No paper found for DOI "${doi}".` : `DOI lookup failed (${res.status}).`);
  }

  const { message } = await res.json();
  const authors = (message.author || [])
    .map((a) => [a.given, a.family].filter(Boolean).join(' ').trim())
    .filter(Boolean);
  const dateParts =
    message.published?.['date-parts']?.[0] ||
    message['published-print']?.['date-parts']?.[0] ||
    message['published-online']?.['date-parts']?.[0] ||
    [];

  return {
    title: (message.title?.[0] || '').replace(/\s+/g, ' ').trim(),
    authors,
    year: dateParts[0] || '',
    doi_or_url: message.DOI ? `https://doi.org/${message.DOI}` : `https://doi.org/${doi}`,
  };
}
